import { useEffect } from 'react';

/**
 * Utility component that removes "New Order" link from the navigation
 * This runs on mount and periodically checks for any dynamically added elements
 */
const RemoveNewOrderLink = () => {
  useEffect(() => {
    // Function to remove any "New Order" links or buttons
    const removeNewOrderLinks = () => {
      // Look for links containing "new-order" in href
      const newOrderLinks = document.querySelectorAll('a[href*="new-order"], a[href*="neworder"]');
      newOrderLinks.forEach(link => {
        if (link instanceof HTMLElement) {
          link.style.display = 'none';
          link.style.visibility = 'hidden';
          link.setAttribute('aria-hidden', 'true');
          link.setAttribute('tabindex', '-1');
        }
      });

      // Look for buttons or links with "New Order" text
      document.querySelectorAll('a, button, .nav-link').forEach(el => {
        if (el.textContent?.includes('New Order')) {
          if (el instanceof HTMLElement) {
            el.style.display = 'none';
            el.style.visibility = 'hidden';
            el.setAttribute('aria-hidden', 'true');
            el.setAttribute('tabindex', '-1');
          }
        }
      });
    };

    // Run immediately
    removeNewOrderLinks();

    // Run on DOM mutations to catch any dynamically added elements
    const observer = new MutationObserver(mutations => {
      removeNewOrderLinks();
    });

    // Start observing the document with the configured parameters
    observer.observe(document.body, { 
      childList: true, 
      subtree: true 
    });

    // Set up periodic checks as a fallback
    const intervalId = setInterval(removeNewOrderLinks, 1000);

    // Cleanup function
    return () => {
      observer.disconnect();
      clearInterval(intervalId);
    };
  }, []);

  return null;
};

export default RemoveNewOrderLink; 